import base from "./base";

const commonAPI = dispatch => {
  return {
    async getAvailableCodes2(search) {
      const response = await base.privateApi(dispatch, {
        path: `/stock/codes/search2=${search}`,
        method: 'get',
      });
      return response;
    },

    async getIndustries(sector) {
      const response = await base.privateApi(dispatch, {
        path: `/common/industry/codes/${sector}`,
        method: 'get',
      });
      return response;
    },

    async getSectors() {
      const response = await base.privateApi(dispatch, {
        path: `/common/sector/list`,
        method: 'get',
      });
      return response;
    },

    async getBIndicator() {
      const response = await base.privateApi(dispatch, {
        path: `/common/bIndicator`,
        method: 'get',
      });
      return response;
    },

    async getNoOfStocks() {
      const response = await base.privateApi(dispatch, {
        path: `/common/no_of_stocks`,
        method: 'get',
      });
      return response;
    },
  };
};

export default commonAPI;
